import { colors, spacing } from '@cabonline/ui-shared';
import { Button, FeedbackModal } from '@cabonline/ui-web';
import { useLocale } from '@multiplatform-apps/service-trips';
import { WarningAmber } from '@mui/icons-material';
import styled from '@emotion/styled';
import React from 'react';

interface SessionWarningModalProps {
  isOpen: boolean;
  onExtend: () => void;
  onLogout: () => void;
  extensionsRemaining: number;
}

const StyledActions = styled.div`
  display: flex;
  gap: ${spacing.xs}px;
  justify-content: center;
`;

const StyledWarningIcon = styled(WarningAmber)`
  color: ${colors.amber};
  font-size: 48px;
`;

export const SessionWarningModal: React.FC<SessionWarningModalProps> = ({
  isOpen,
  onExtend,
  onLogout,
  extensionsRemaining,
}) => {
  const { t } = useLocale();

  if (!isOpen) return null;

  return (
    <FeedbackModal
      isOpen={isOpen}
      title={t('sessionTimeout.warningTitle')}
      text={t('sessionTimeout.warningText')}
      icon={<StyledWarningIcon aria-hidden="true" />}
      role="alertdialog"
      showCloseButton={false}
      actions={
        <StyledActions>
          {extensionsRemaining > 0 && (
            <Button
              variant="primary"
              label={t('sessionTimeout.extendButton')}
              onClick={onExtend}
              testID="session-extend-button"
            />
          )}
          <Button
            variant="secondary"
            label={t('sessionTimeout.logoutButton')}
            onClick={onLogout}
            testID="session-logout-button"
          />
        </StyledActions>
      }
    />
  );
};
